import React from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
// import { noteActions } from '_actions';
// import styles from './Common.module.css';

class PatientCareCenterNoteGoalsGoalDetailsPeds extends React.Component {

    render() {
        return (

            <div>
                {'Peds Goal - ' + this.props.activityName}
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        // selectGoal: bindActionCreators(noteActions.selectGoal, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '';

    return {
        noteId: noteId,
        goal: goal,
        activityName: activityName,
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsPeds = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsPeds);
export { connectedPatientCareCenterNoteGoalsGoalDetailsPeds as PatientCareCenterNoteGoalsGoalDetailsPeds };

